import React from 'react';
import ImageDropzone from '../ImageDropzone';

const Req = () => <span style={{ color: '#e53e3e', marginLeft: '3px', fontWeight: '700' }}>*</span>;

const PageBannerModal = ({ editItem, modalImageUrl, setModalImageUrl, onSave, onClose }) => {
    return (
        <div className="admin-modal-overlay" onClick={onClose}>
            <div className="admin-modal-card" onClick={(e) => e.stopPropagation()}>
                <div className="admin-modal-header">
                    <h3><i className="fa fa-flag m-r10" style={{ color: '#f03a02' }} /> Edit {editItem?.name || 'Page Banner'}</h3>
                    <button className="close-btn" onClick={onClose}>✕</button>
                </div>
                <form onSubmit={onSave} className="admin-modal-body">
                    <div>
                        <label className="admin-label">Banner Page Title<Req /></label>
                        <input type="text" name="title" defaultValue={editItem?.title || ''} className="admin-input" required />
                    </div>
                    <div className="m-t15">
                        <label className="admin-label">Banner Content / Subtitle Description<Req /></label>
                        <textarea name="description" defaultValue={editItem?.description || ''} className="admin-textarea" rows="3" required />
                    </div>

                    {/* BANNER BACKGROUND IMAGE UPLOADER */}
                    <ImageDropzone
                        label="Banner Background Image"
                        value={modalImageUrl}
                        onChange={setModalImageUrl}
                        fallback="/images/banner/6.jpg"
                    />

                    <div className="admin-modal-footer m-t20">
                        <button type="button" className="admin-btn admin-btn-secondary" onClick={onClose}>Cancel</button>
                        <button type="submit" className="admin-btn admin-btn-primary"><i className="fa fa-save m-r5" /> Save Page Banner</button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PageBannerModal;
